import { DoorOpening } from "./DoorOpening";
import { DoorPoint } from "./DoorPoint";
import { DoorType } from "./DoorType";
import { Hardware } from "./Hardware";

export class Door extends DoorOpening {
  imageUrl: string;
  hardware?: Hardware;

  constructor(
    imageUrl: string,
    doorType: DoorType,
    topLeft: DoorPoint,
    topRight: DoorPoint,
    bottomLeft: DoorPoint,
    bottomRight: DoorPoint,
    chamferedEdgeLeft?: DoorPoint,
    chamferedEdgeRight?: DoorPoint,
    archEdgeLeft?: DoorPoint,
    hardware?: Hardware
  ) {
    super(
      doorType,
      topLeft,
      topRight,
      bottomLeft,
      bottomRight,
      chamferedEdgeLeft,
      chamferedEdgeRight,
      archEdgeLeft
    );

    this.imageUrl = imageUrl;
    this.hardware = hardware;
  }
}
